// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/_css-loader@3.6.0@css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-submenu.is-active>.el-submenu__title{color:#fffff3!important}.full-mode .el-submenu .el-menu-item,.full-mode .nest-menu .el-submenu>.el-submenu__title{min-width:185px!important}.simple-mode.first-level .submenu-title-noDropdown{padding:0!important;position:relative}.simple-mode.first-level .submenu-title-noDropdown .el-tooltip{padding:0!important}.simple-mode.first-level .el-submenu{overflow:hidden}.simple-mode.first-level .el-submenu>.el-submenu__title{padding:0!important}.simple-mode.first-level .el-submenu>.el-submenu__title .el-submenu__icon-arrow{display:none}.simple-mode.first-level .el-submenu>.el-submenu__title>span{visibility:hidden}", ""]);
// Exports
exports.locals = {
	"menuBg": "#414146",
	"menuText": "#e0e3da",
	"menuActiveText": "#fffff3"
};
module.exports = exports;
